export default class Str {
    /**
     * @param pattern {String}
     * @param value {String}
     * @return {boolean|*}
     */
    static is(pattern, value) {
        if (pattern === value) {
            return true
        }

        return value.match(`^${pattern.replace(new RegExp(`[.\\\\+*?\\[^\\]$(){}=!<>|:\\${'#' || ''}-]`, 'g'), '\\$&')
            .replace('*', '.*')}`)
    }
}
